import { EmptyRegisters } from "../entities/registers";
import { MinerAddressMainnet, MinerAddressTestnet } from "../constants";
import { ergoTreeFromAddress } from "../entities/ergoTree";
export class DefaultTxAssembler {
    constructor(mainnet) {
        this.mainnet = mainnet;
    }
    assemble(req, ctx) {
        const change = req.inputs.change;
        const changeBox = change
            ? [
                {
                    value: change.value,
                    ergoTree: ergoTreeFromAddress(req.changeAddress),
                    creationHeight: ctx.height,
                    assets: change.assets,
                    additionalRegisters: EmptyRegisters
                }
            ]
            : [];
        const feeBox = req.feeNErgs
            ? [
                {
                    value: req.feeNErgs,
                    ergoTree: ergoTreeFromAddress(this.mainnet ? MinerAddressMainnet : MinerAddressTestnet),
                    creationHeight: ctx.height,
                    assets: [],
                    additionalRegisters: EmptyRegisters
                }
            ]
            : [];
        const outputs = [...req.outputs, ...changeBox, ...feeBox];
        return {
            inputs: req.inputs.unsignedInputs,
            dataInputs: req.dataInputs,
            outputs: outputs
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHhBc3NlbWJsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvd2FsbGV0L3R4QXNzZW1ibGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLE9BQU8sRUFBQyxjQUFjLEVBQUMsTUFBTSx1QkFBdUIsQ0FBQTtBQUNwRCxPQUFPLEVBQUMsbUJBQW1CLEVBQUUsbUJBQW1CLEVBQUMsTUFBTSxjQUFjLENBQUE7QUFDckUsT0FBTyxFQUFDLG1CQUFtQixFQUFDLE1BQU0sc0JBQXNCLENBQUE7QUFNeEQsTUFBTSxPQUFPLGtCQUFrQjtJQUM3QixZQUE0QixPQUFnQjtRQUFoQixZQUFPLEdBQVAsT0FBTyxDQUFTO0lBQUcsQ0FBQztJQUVoRCxRQUFRLENBQUMsR0FBYyxFQUFFLEdBQW1CO1FBQzFDLE1BQU0sTUFBTSxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFBO1FBQ2hDLE1BQU0sU0FBUyxHQUFHLE1BQU07WUFDdEIsQ0FBQyxDQUFDO2dCQUNFO29CQUNFLEtBQUssRUFBRSxNQUFNLENBQUMsS0FBSztvQkFDbkIsUUFBUSxFQUFFLG1CQUFtQixDQUFDLEdBQUcsQ0FBQyxhQUFhLENBQUM7b0JBQ2hELGNBQWMsRUFBRSxHQUFHLENBQUMsTUFBTTtvQkFDMUIsTUFBTSxFQUFFLE1BQU0sQ0FBQyxNQUFNO29CQUNyQixtQkFBbUIsRUFBRSxjQUFjO2lCQUNwQzthQUNGO1lBQ0gsQ0FBQyxDQUFDLEVBQUUsQ0FBQTtRQUNOLE1BQU0sTUFBTSxHQUFHLEdBQUcsQ0FBQyxRQUFRO1lBQ3pCLENBQUMsQ0FBQztnQkFDRTtvQkFDRSxLQUFLLEVBQUUsR0FBRyxDQUFDLFFBQVE7b0JBQ25CLFFBQVEsRUFBRSxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxtQkFBbUIsQ0FBQyxDQUFDLENBQUMsbUJBQW1CLENBQUM7b0JBQ3ZGLGNBQWMsRUFBRSxHQUFHLENBQUMsTUFBTTtvQkFDMUIsTUFBTSxFQUFFLEVBQUU7b0JBQ1YsbUJBQW1CLEVBQUUsY0FBYztpQkFDcEM7YUFDRjtZQUNILENBQUMsQ0FBQyxFQUFFLENBQUE7UUFDTixNQUFNLE9BQU8sR0FBRyxDQUFDLEdBQUcsR0FBRyxDQUFDLE9BQU8sRUFBRSxHQUFHLFNBQVMsRUFBRSxHQUFHLE1BQU0sQ0FBQyxDQUFBO1FBQ3pELE9BQU87WUFDTCxNQUFNLEVBQUUsR0FBRyxDQUFDLE1BQU0sQ0FBQyxjQUFjO1lBQ2pDLFVBQVUsRUFBRSxHQUFHLENBQUMsVUFBVTtZQUMxQixPQUFPLEVBQUUsT0FBTztTQUNqQixDQUFBO0lBQ0gsQ0FBQztDQUNGIn0=